/** Auth */
export const TOKEN_EXITOSO = "TOKEN_EXITOSO";
export const TOKEN_ERROR = "TOKEN_ERROR";
export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const RECUPERAR_EXITOSO = "RECUPERAR_EXITOSO";
export const RECUPERAR_ERROR = "RECUPERAR_ERROR";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";
/** Alertas */
export const MOSTRAR_ALERTA = "MOSTRAR_ALERTA";
export const OCULTAR_ALERTA = "OCULTAR_ALERTA";
/** Resultados */
export const OBTENER_RESULTADOS = "OBTENER_RESULTADOS";
export const ERROR_OBTENER_RESULTADOS = "ERROR_OBTENER_RESULTADOS";
export const PAGINA_ACTUAL = "PAGINA_ACTUAL";
export const OBTENER_ID_RESULTADO_SELECCIONADO =
  "OBTENER_ID_RESULTADO_SELECCIONADO";
export const OBTENER_VALIDACION = "OBTENER_VALIDACION";
export const ERROR_OBTENER_VALIDACION = "ERROR_OBTENER_VALIDACION";
/** Detalle del resultado */
export const OBTENER_RESULTADO_DETALLE = "OBTENER_RESULTADO_DETALLE";
export const ERROR_OBTENER_RESULTADO_DETALLE =
  "ERROR_OBTENER_RESULTADO_DETALLE";
/** Detalle del resultado archivos digitales */
export const OBTENER_ARCHIVOS_DETALLE = "OBTENER_ARCHIVOS_DETALLE";
export const ERROR_OBTENER_ARCHIVOS_DETALLE = "ERROR_OBTENER_ARCHIVOS_DETALLE";
export const OBTENER_ARCHIVOS_DETALLE_PDF = "OBTENER_ARCHIVOS_DETALLE_PDF";
export const ERROR_OBTENER_ARCHIVOS_DETALLE_PDF =
  "ERROR_OBTENER_ARCHIVOS_DETALLE_PDF";
/** Citas */
export const INIT_REGISTRO_CITA = "INIT_REGISTRO_CITA";
export const REGISTRO_CITA_EXITOSO = "REGISTRO_CITA_EXITOSO";
export const REGISTRO_CITA_ERROR = "REGISTRO_CITA_ERROR";
export const OBTENER_SUCURSALES_SUCCESS = "OBTENER_SUCURSALES_SUCCESS";
export const OBTENER_SUCURSALES_ERROR = "OBTENER_SUCURSALES_ERROR";
export const OBTENER_ESTUDIOS_SUCCESS = "OBTENER_ESTUDIOS_SUCCESS";
export const OBTENER_ESTUDIOS_ERROR = "OBTENER_ESTUDIOS_ERROR";
export const OBTENER_CITAS = "OBTENER_CITAS";
export const OBTENER_CITAS_EXITOSO = "OBTENER_CITAS_EXITOSO";
export const OBTENER_CITAS_ERROR = "OBTENER_CITAS_ERROR";
/** Prospectos */
export const INIT_REGISTRO_PROSPECTO = "INIT_REGISTRO_PROSPECTO";
export const REGISTRO_PROSPECTO_EXITOSO = "REGISTRO_PROSPECTO_EXITOSO";
export const REGISTRO_PROSPECTO_ERROR = "REGISTRO_PROSPECTO_ERROR";
export const INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE =
  "INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE";
export const OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO =
  "OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO";
export const OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR =
  "OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR";
export const INIT_OBTENER_PROSPECTOS = "INIT_OBTENER_PROSPECTOS";
export const OBTENER_PROSPECTOS_EXITOSO = "OBTENER_PROSPECTOS_EXITOSO";
export const OBTENER_PROSPECTOS_ERROR = "OBTENER_PROSPECTOS_ERROR";
/** Pacientes */
